import { useCallback, useEffect, useState } from 'react'
import { listTrainingVideos } from '../../services/trainingsService'
import type { TrainingVideo } from '../../types/Training/TrainingVideo'

type VisibleTutorialsState = {
	tutorials: TrainingVideo[]
	isLoading: boolean
	errorMessage: string | null
	refetch: () => Promise<void>
}

export const useVisibleTutorials = (): VisibleTutorialsState => {
	const [tutorials, setTutorials] = useState<TrainingVideo[]>([])
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const loadTutorials = useCallback(async () => {
		setIsLoading(true)
		setErrorMessage(null)

		try {
			const tutorialList = await listTrainingVideos()
			setTutorials(tutorialList)
		} catch {
			setErrorMessage('Unable to load tutorials right now.')
			setTutorials([])
		} finally {
			setIsLoading(false)
		}
	}, [])

	useEffect(() => {
		void loadTutorials()
	}, [loadTutorials])

	const refetch = useCallback(async () => {
		await loadTutorials()
	}, [loadTutorials])

	return {
		tutorials,
		isLoading,
		errorMessage,
		refetch,
	}
}
